<template>
  <v-container fluid>
    <!-- Overview Cards -->
    <v-row>
      <!-- Users Overview Card -->
      <v-col cols="12" md="6" lg="4">
        <v-card :color="userCardColor" :variant="variant" class="mx-auto">
          <v-card-item>
            <div>
              <div class="text-overline mb-1">Users Overview</div>
              <div class="text-h6 mb-1">Manage Users</div>
              <div class="text-caption">View and manage all registered users</div>
            </div>
          </v-card-item>
          <v-card-actions>
            <v-btn @click="goToUsers">View Users</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Products Overview Card -->
      <v-col cols="12" md="6" lg="4">
        <v-card :color="productsCardColor" :variant="variant" class="mx-auto">
          <v-card-item>
            <div>
              <div class="text-overline mb-1">Products Overview</div>
              <div class="text-h6 mb-1">Manage Products</div>
              <div class="text-caption">View and manage all products</div>
            </div>
          </v-card-item>
          <v-card-actions>
            <v-btn @click="goToProducts">View Products</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Message Overview Card -->
      <v-col cols="12" md="6" lg="4">
        <v-card :color="messageCardColor" :variant="variant" class="mx-auto">
          <v-card-item>
            <div>
              <div class="text-overline mb-1">Messages Overview</div>
              <div class="text-h6 mb-1">Manage Messages</div>
              <div class="text-caption">View and respond to all messages</div>
            </div>
          </v-card-item>
          <v-card-actions>
            <v-btn @click="goToMessages">View Messages</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Settings Menu Card -->
      <v-col cols="12" md="6" lg="4">
        <v-card :color="settingsCardColor" :variant="variant" class="mx-auto">
          <v-card-item>
            <div>
              <div class="text-overline mb-1">Settings</div>
              <div class="text-h6 mb-1">Manage System Settings</div>
              <div class="text-caption">Configure system preferences and settings</div>
            </div>
          </v-card-item>
          <v-card-actions>
            <v-menu offset-y>
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props">Open Menu</v-btn>
              </template>
              <v-list>
                <v-list-item-group>
                  <v-list-item
                    v-for="item in siteManagementItems"
                    :key="item.title"
                    :to="item.to"
                    link
                    tag="router-link"
                  >
                    <v-list-item-icon>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Orders Card (Coming Soon) -->
      <v-col cols="12" md="6" lg="4">
        <v-card :color="ordersCardColor" :variant="variant" class="mx-auto">
          <v-card-item>
            <div>
              <div class="text-overline mb-1">Orders</div>
              <div class="text-h6 mb-1">Coming Soon</div>
              <div class="text-caption">This feature is coming soon. Stay tuned!</div>
            </div>
          </v-card-item>
          <v-card-actions>
            <v-btn disabled>Not Available</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Reviews Card (Coming Soon) -->
      <v-col cols="12" md="6" lg="4">
        <v-card :color="reviewsCardColor" :variant="variant" class="mx-auto">
          <v-card-item>
            <div>
              <div class="text-overline mb-1">Reviews</div>
              <div class="text-h6 mb-1">Coming Soon</div>
              <div class="text-caption">This feature is coming soon. Stay tuned!</div>
            </div>
          </v-card-item>
          <v-card-actions>
            <v-btn disabled>Not Available</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      color: 'primary', // Base color for the card
      variant: 'tonal', // Card variant
      userCardColor: 'blue', // Color for Users Overview card
      productsCardColor: 'green', // Color for Products Overview card
      messageCardColor: 'cyan', // Color for Messages Overview card
      articleCardColor: 'warning',
      settingsCardColor: 'orange', // Color for Settings card
      ordersCardColor: 'grey', // Color for Orders card
      reviewsCardColor: 'purple', // Color for Reviews card
      siteManagementItems: [
        { title: "Home Section", icon: "mdi-monitor", to: "/admin/home-section" },
        { title: "Banner", icon: "mdi-monitor", to: "/admin/banner-manager" },
        { title: "About & Contact", icon: "mdi-monitor", to: "/admin/about-contact-manager" },
        { title: "Site Setting", icon: "mdi-monitor", to: "/admin/site-setting" },
      ],
    };
  },
  methods: {
    goToUsers() {
      this.$router.push('/admin/users');
    },
    goToProducts() {
      this.$router.push('/admin/products');
    },
    goToMessages() {
      this.$router.push('/admin/message');
    },
    goToArticles(){
      this.$router.push('/admin/article');
    }
  },
};
</script>

<style scoped>
/* Styles for Dashboard */
.v-card-item {
  display: flex;
  align-items: center;
  padding: 16px;
}

.v-card-actions {
  justify-content: flex-start;
}

.text-h6 {
  font-size: 1.25rem;
  font-weight: 500;
}

.text-caption {
  color: #666;
}
</style>
